<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
    <mapfre-card [singleCard]="false" [additionalClasses]="'billing-discount fs-18 lh-24'">
        <div class="border-bottom-1-9CB0BC fs-16 pb-3 mb-4">
            <h1 class="title-copy mb-0 dm-sans font-weight-normal">{{ "Discount" | translate }}</h1>
        </div>
         
        <app-billing-header 
            [policyTypeImg]="policyTypeImg" [policyType]="policyType" 
            [policyNumber]="policy?.policynumber.policyNumber" [policy]="policy"
        >
        </app-billing-header>

        <form name="billingDiscountForm" class="ng-select-main submit-question-form" [formGroup]="billingDiscountForm"
            (ngSubmit)="billingDiscountForm?.valid && onSubmit()" [ngClass]="{'text-left ma-submit-question-form': !isAcmic}">
            <div class="margin-top mt16 fs-16">
                <label for="select-policy" class="select-label mb-0">{{ "SELECT_DISCOUNT" | translate }}</label>
                <ng-select 
                [items]="discountOptions" 
                bindLabel="name" 
                autofocus 
                bindValue="name" 
                [searchable]="false" 
                [multiple]="false"
                [clearable]="false" 
                [markFirst]="false" 
                placeholder="Select one" 
                fixedPlaceholder="true"
                [formControlName]="'discount'"
                (change)="onDiscountChange()"> 
                </ng-select>
            </div>
            <div *ngIf="this.billingDiscountForm.controls.discount.value ==='Select one'"
                class="error-block form-control no-padding-left no-padding-top border border-0 rounded-0 h-auto">
                {{ 'SELECTION_IS_REQUIRED' | translate }}
            </div>

            <div class="additional-info" *ngIf="billingDiscountForm?.controls?.discount?.valid">
                <label for="select-topic" class="select-label mb-0">
                    {{ "ADD_ADDITIONAL_INFO" | translate}}
                </label>
                <textarea [formControlName]="'additionalInfoText'" placeholder="Type here" class="billing-text" mdbInput></textarea>
            </div>
            <div class="form-control p-0 border border-0 rounded-0 h-auto">
                <ng-container *ngIf="billingDiscountForm.controls.discount.valid">
                    <div class="mb-4">
                        <ng-container *ngIf="billingDiscountForm.controls.discount.value === 'Good Student discount'">
                            <p class="mt-4">
                            {{ "THE_GOOD_STUDENT_DISCOUNT" | translate}}
                            </p>
                            <p class="mb-0">
                                {{ "THE_MOST_CURRENT_STUDENT" | translate}}
                            </p>
                        </ng-container>
                        <ng-container
                        *ngIf="billingDiscountForm.controls.discount.value === 'Pan-Mass Challenge discount'">
                        <p class="mt-4">
                                {{ "THE_PANMASS_CHALLENGE_DISCOUNT" | translate}}
                                </p>
                                <p class="mb-0">
                                {{ "A_DONATION_RECEIPT" | translate}}
                                </p>
                            </ng-container>
                            <ng-container *ngIf="billingDiscountForm.controls.discount.value === 'Student Away discount'">
                                <p class="mt-4">
                                {{ "FOR_THIS_DISCOUNT_TO_APPLY" | translate}}
                                </p>
                                <p class="mb-0">
                                {{ "A_COPY_OF_THE_DRIVERS" | translate}}
                            </p>
                        </ng-container>
                    </div>
                <app-upload-request-documents (uploadFileEvent)="saveUploadedFile($event)">
                </app-upload-request-documents>
                </ng-container>
            </div>

            <div class="row text-center mt-4">
                <div class="col billing-request-btn">
                    <mapfre-button 
                        [ngClass]="{'custom_loader':submitLoading}"
                        [additionalClasses]="'basic primary large-btn waves-effect'" [inputType]="'submit'"
                        [disabledValue]="billingDiscountForm?.valid && documents?.length > 0"
                        [translateValue]="'SUBMIT' | translate"></mapfre-button>
                </div>
            </div>

            <div class="row text-center mt-3">
                <div class="col billing-request-btn">
                    <mapfre-button [additionalClasses]="'ghost secondary large-btn mx-auto height-56'"
                        [iconClasses]="'align-middle'"
                        (click)="onClickBack()">
                        {{ 'BACK' | translate }}
                    </mapfre-button>
                </div>
            </div>

        </form>
    </mapfre-card>
</ng-container>

<app-leave-page-modal
    *ngIf="showLeaveModal"
      (isLeavingPage)="reload($event)">
</app-leave-page-modal>

<mapfre-modal
  *ngIf="showSubmitUnsuccessModal"
      [modalOptions]="failureSubmitModal"
      [hideModal]="hideModal"
      (closeModal)="resetHideModal()"
    >
    <app-request-unsuccess
        (isTryAgain)="tryAgain($event)">
    </app-request-unsuccess>
</mapfre-modal>